import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchTransfer', request, cancelToken)
}

export {get}
